import React from "react";
import { Descriptions, Table } from "antd";
import moment from "moment";

const RiderStatusLists = (props) => {
  const dataSource = [
    {
      key: '1',
      name: 'Order Land to Packed',
      buffer_time: props.orderData.estimated_order_processing_time.order_land_to_packed_time ? props.orderData.estimated_order_processing_time.order_land_to_packed_time : "-",
      order_processing_time_promissed: props.orderData.estimated_order_processing_time.order_land_to_packed_calculated ? moment(props.orderData.estimated_order_processing_time.order_land_to_packed_calculated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
      order_processing_time_updated: props.orderData.estimated_order_processing_time.order_land_to_packed_updated ? moment(props.orderData.estimated_order_processing_time.order_land_to_packed_updated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
    },
    {
      key: '2',
      name: 'Packed to Rider Accepted',
      buffer_time: props.orderData.estimated_order_processing_time.packed_to_rider_accepted_time ? props.orderData.estimated_order_processing_time.packed_to_rider_accepted_time : "-",
      order_processing_time_promissed: props.orderData.estimated_order_processing_time.packed_to_rider_accepted_calculated ? moment(props.orderData.estimated_order_processing_time.packed_to_rider_accepted_calculated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
      order_processing_time_updated: props.orderData.estimated_order_processing_time.packed_to_rider_accepted_updated ? moment(props.orderData.estimated_order_processing_time.packed_to_rider_accepted_updated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
    },
    {
      key: '3',
      name: 'Accepted to Pickup',
      buffer_time: props.orderData.estimated_order_processing_time.accepted_to_pickup_time ? props.orderData.estimated_order_processing_time.accepted_to_pickup_time : "-",
      order_processing_time_promissed: props.orderData.estimated_order_processing_time.accepted_to_pickup_calculated ? moment(props.orderData.estimated_order_processing_time.accepted_to_pickup_calculated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
      order_processing_time_updated: props.orderData.estimated_order_processing_time.accepted_to_pickup_updated ? moment(props.orderData.estimated_order_processing_time.accepted_to_pickup_updated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
    },
    {
      key: '4',
      name: 'Pickup to Dropoff Started',
      buffer_time: props.orderData.estimated_order_processing_time.pickup_to_dropoff_started_time ? props.orderData.estimated_order_processing_time.pickup_to_dropoff_started_time : "-",
      order_processing_time_promissed: props.orderData.estimated_order_processing_time.pickup_to_dropoff_started_calculated ? moment(props.orderData.estimated_order_processing_time.pickup_to_dropoff_started_calculated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
      order_processing_time_updated: props.orderData.estimated_order_processing_time.pickup_to_dropoff_started_updated ? moment(props.orderData.estimated_order_processing_time.pickup_to_dropoff_started_updated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
    },
    {
      key: '5',
      name: 'Dropoff Started to Dropoff Complete',
      buffer_time: props.orderData.estimated_order_processing_time.dropoff_started_to_dropoff_complete_time ? props.orderData.estimated_order_processing_time.dropoff_started_to_dropoff_complete_time : "-",
      order_processing_time_promissed: props.orderData.estimated_order_processing_time.dropoff_started_to_dropoff_complete_calculated ? moment(props.orderData.estimated_order_processing_time.dropoff_started_to_dropoff_complete_calculated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
      order_processing_time_updated: props.orderData.estimated_order_processing_time.dropoff_started_to_dropoff_complete_updated ? moment(props.orderData.estimated_order_processing_time.dropoff_started_to_dropoff_complete_updated).format("DD MMMM, yyyy, h:mm:ss A") : "-",
    },
   
  ];
  
  const columns = [
    {
      title: '',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Buffer Time',
      dataIndex: 'buffer_time',
      key: 'buffer_time',
    },
    {
      title: 'Order Processing Time Promissed',
      dataIndex: 'order_processing_time_promissed',
      key: 'order_processing_time_promissed',
    },
    {
      title: 'Order Processing Time Updated',
      dataIndex: 'order_processing_time_updated',
      key: 'order_processing_time_updated',
    },
  ];

  return (
    <>
      <Descriptions className="listLabelBold">
        <Descriptions.Item label="Status" span={3}>
          {props.orderData && props.orderData.job_type ? props.orderData.job_type : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Order date/time" span={3}>
          {props.orderData && props.orderData.created_at ?moment(props.orderData.created_at).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Rider buffer time" span={3}>
          {props.orderData.estimated_delivery_time.rider_buffer_time ? props.orderData.estimated_delivery_time.rider_buffer_time+" minutes" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Estimated driving time" span={3}>
          {props.orderData.estimated_delivery_time.on_route_time ? props.orderData.estimated_delivery_time.on_route_time_hr : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Estimated Customer Reach Time (Promised)" span={3}>
          {props.orderData.estimated_delivery_time.estimated_time_reached_at_customer_hr ? moment(props.orderData.estimated_delivery_time.estimated_time_reached_at_customer_hr).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Customer buffer time" span={3}>
          {props.orderData.estimated_delivery_time.customer_buffer_time ? props.orderData.estimated_delivery_time.customer_buffer_time+" minutes" : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Estimated delivery time (Promised)" span={3}>
          {props.orderData.estimated_delivery_time.edt_promised_hr ? moment(props.orderData.estimated_delivery_time.edt_promised_hr).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Estimated Customer Reach Time (Updated)" span={3}>
          {props.orderData.estimated_delivery_time.estimated_time_reached_at_customer_updated_hr ? moment(props.orderData.estimated_delivery_time.estimated_time_reached_at_customer_updated_hr).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Estimated Delivery Time (Updated)" span={3}>
          {props.orderData.estimated_delivery_time.edt_updated_hr ? moment(props.orderData.estimated_delivery_time.edt_updated_hr).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>

        <Descriptions.Item label="Rider traffic buffer time" span={3}>
          {props.orderData.arrive_and_pickup_time.rider_traffic_buffer ? props.orderData.arrive_and_pickup_time.rider_traffic_buffer+" minutes" : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Rider pickup buffer time" span={3}>
          {props.orderData.arrive_and_pickup_time.rider_pickup_buffer ? props.orderData.arrive_and_pickup_time.rider_pickup_buffer+" minutes" : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Arrive at mart & Pickup time in minutes" span={3}>
          {props.orderData.arrive_and_pickup_time.time_calculated ? props.orderData.arrive_and_pickup_time.time_calculated+" minutes" : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Arrive at mart & Pickup time" span={3}>
          {props.orderData.arrive_and_pickup_time.time_calculated_hr ? moment(props.orderData.arrive_and_pickup_time.time_calculated_hr).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>
        {/* calculted inhttps://kravemart.atlassian.net/browse/RAB-896 but reqestedt to remove those in ticket https://kravemart.atlassian.net/browse/RAB-1085 */}
        {/* <Descriptions.Item label="Estimated Customer Buffer time duration" span={3}>
          {props.orderData.estimated_delivery_time.estimated_customer_buffer_time_duration ? props.orderData.estimated_delivery_time.estimated_customer_buffer_time_duration+" minutes" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Actual Customer Reach Time" span={3}>
          {props.orderData.estimated_delivery_time.customer_reached_time_actual ? moment(props.orderData.estimated_delivery_time.customer_reached_time_actual).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item> */}

        {/* <Descriptions.Item label="Promised delivery time" span={3}> */}
        {/* <Descriptions.Item label="Pick-up (Commited)" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Pick-up (Updated)" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Time order created at mart" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Estimated picking time" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Estimated time to pickup" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> */}
        {/* <Descriptions.Item label="Estimated rider delay" span={3}> */}
        {/* <Descriptions.Item label="Estimated pick-up duration" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Distance pickup to dropoff (Manhattan)" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Cash on delivery" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="Scheduled order" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> 
        <Descriptions.Item label="New customer" span={3}>
          {props.orderData ? "-" : "-"}
        </Descriptions.Item> */}
        <Descriptions.Item label="Payment type" span={3}>
          {props.orderData && props.orderData.order_details && props.orderData.order_details.payment_type && props.orderData.order_details.payment_type.title ?
          props.orderData.order_details.payment_type.title : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Charged to Rider" span={3}>
          {props.orderData && props.orderData.charge_to_rider && props.orderData.charge_to_rider.charge_to_rider_status == true ?
            "Yes" : "No"}
        </Descriptions.Item>
        <Descriptions.Item label="Charged Amount" span={3}>
          { 
            props.orderData && props.orderData.charge_to_rider && props.orderData.charge_to_rider.charge_to_rider_status == true ?
              (props.orderData && props.orderData.order_details && props.orderData.order_details.cancel_order_charge_amount ?
                props.orderData.order_details.cancel_order_charge_amount : "-")
              : 
              "-"
          }
        </Descriptions.Item>
        <Descriptions.Item label="Charged by" span={3}>
          {props.orderData && props.orderData.charge_to_rider && props.orderData.charge_to_rider.charge_to_rider_user ?
            props.orderData.charge_to_rider.charge_to_rider_user.name : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Charged time" span={3}>
          {props.orderData && props.orderData.charge_to_rider && props.orderData.charge_to_rider.charge_to_rider_at ?
            moment(props.orderData.charge_to_rider.charge_to_rider_at).format("DD MMMM, yyyy, h:mm:ss A") : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Estimated order processing time current" span={3}>
          {props.orderData.estimated_order_processing_time.estimated_order_processing_time_current ? props.orderData.estimated_order_processing_time.estimated_order_processing_time_current+" minutes" : "-"}
        </Descriptions.Item>
        
      </Descriptions>
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </>
  );
};
export default RiderStatusLists;
